// extracted by mini-css-extract-plugin
export default {"container":"AllStudentsWork_container__xZ7dU","wrapper":"AllStudentsWork_wrapper__06iE+","title":"AllStudentsWork_title__EO4e8","card":"AllStudentsWork_card__iRN-A"};